import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import WarningIcon from '@material-ui/icons/ReportProblem';
import ErrorIcon from '@material-ui/icons/Error';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';

const useStyles = makeStyles((theme) => {
   const succesColor = theme.succes ? theme.succes.light : 'green';
   const warningColor = theme.succes ? theme.succes.light : 'orange';
   const errorColor = theme.succes ? theme.succes.light : 'red';
   return {
      divider: {
         borderTop: '1px solid #D3D3D3'
      },
      succes: {
         color: succesColor
      },
      warning: {
         color: warningColor
      },
      error: {
         color: errorColor
      },
      actions: {
         width: '94%'
      }
   };
});

function ConfirmDialog({
   titulo,
   children,
   open,
   setOpen,
   onConfirm,
   variant,
   disableTypography,
   onCancel,
   buttonSize,
   cancelStyle,
   confirmStyle,
   cancelVariant,
   confirmVariant,
   cancelText,
   confirmText,
   ...other
}) {
   const classes = useStyles();
   function tituloMostrar() {
      if (!titulo) {
         switch (variant) {
            case 'success':
               return 'Exito';
            case 'warning':
               return 'Advertencia';
            case 'error':
               return 'Error';
            default:
               return '';
         }
      }
      return titulo;
   }
   function closeDialog() {
      onCancel();
      setOpen(false);
   }
   return (
      <Dialog
         open={open}
         onClose={closeDialog}
         aria-labelledby="confirm-dialog"
         fullWidth
         {...other}
      >
         <DialogTitle disableTypography>
            <Grid container alignItems="center">
               <Grid item xs={1}>
                  {variant === 'success' && <SuccessIcon className={classes.succes} />}
                  {variant === 'warning' && <WarningIcon className={classes.warning} />}
                  {variant === 'error' && <ErrorIcon className={classes.error} />}
               </Grid>
               <Grid item xs={11}>
                  <Typography component="h2" variant="h6">
                     {tituloMostrar()}
                  </Typography>
               </Grid>
            </Grid>
         </DialogTitle>
         {children && (
            <DialogContent>
               {disableTypography ? (
                  children
               ) : (
                  <Typography component="p" variant="body1">
                     {children}
                  </Typography>
               )}
            </DialogContent>
         )}
         <DialogActions className={classes.divider}>
            <Grid container justify="space-between">
               <Grid container item xs={3} justify="flex-start">
                  <Button
                     size={buttonSize}
                     variant={cancelVariant}
                     onClick={closeDialog}
                     color="default"
                     style={cancelStyle}
                  >
                     {cancelText}
                  </Button>
               </Grid>
               <Grid container item xs={3} justify="flex-end">
                  <Button
                     size={buttonSize}
                     variant={confirmVariant}
                     onClick={() => {
                        onConfirm();
                        setOpen(false);
                     }}
                     color="secondary"
                     style={confirmStyle}
                  >
                     {confirmText}
                  </Button>
               </Grid>
            </Grid>
         </DialogActions>
      </Dialog>
   );
}

ConfirmDialog.propTypes = {
   open: PropTypes.bool.isRequired,
   setOpen: PropTypes.func.isRequired,
   titulo: PropTypes.string,
   onConfirm: PropTypes.func,
   onCancel: PropTypes.func,
   variant: PropTypes.oneOf(['default', 'success', 'warning', 'error']),
   buttonSize: PropTypes.oneOf(['small', 'medium', 'large']),
   cancelVariant: PropTypes.oneOf(['text', 'outlined', 'contained']),
   confirmVariant: PropTypes.oneOf(['text', 'outlined', 'contained']),
   cancelText: PropTypes.string,
   confirmText: PropTypes.string
};
ConfirmDialog.defaultProps = {
   variant: 'default',
   buttonSize: 'medium',
   confirmVariant: 'contained',
   cancelText: 'No',
   confirmText: 'Si',
   onConfirm: () => {
      return;
   },
   onCancel: () => {
      return;
   }
};
export default ConfirmDialog;
